import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[addressNumberTwo]',
    standalone: false
})
export class AddressNumberTwoDirective {
	constructor(private el: ElementRef) {
		setTimeout(() => {
			this.onChange(this.el.nativeElement.value);
		}, 500);
	}

	@HostListener('change', ['$event'])
	onChange(event: Event | string): void {
		const inputValue = this.el.nativeElement.value;

		const maskedValue = this.applyCustomMask(inputValue);

		this.el.nativeElement.value = maskedValue;
	}

	@HostListener('input', ['$event'])
	onInput(event: Event): void {
		const inputValue = this.el.nativeElement.value;

		const maskedValue = this.applyCustomMask(inputValue);

		this.el.nativeElement.value = maskedValue;
	}

	private applyCustomMask(value: string): string {
		// Remove caracteres especiais e acentos
		const sanitizedValue = value.replace(/[^a-zA-Z0-9-]/g, '');

		// Adiciona "-" no início se ainda não estiver presente
		const maskedValue = sanitizedValue.startsWith('-') ? sanitizedValue : '-' + sanitizedValue;

		return maskedValue;
	}
}
